export const tracks = [
  {
    id: 1,
    title: "C.R.E.A.M - Wu Tang Clan",
    src: "/audio/test.mp3",
  },
  {
    id: 2,
    title: "Dummy Track 2",
    src: "/audio/test_two.mp3",
  },
  {
    id: 3,
    title: "Dummy Track 3",
    src: "/audio/test_three.mp3",
  },
  {
    id: 4,
    title: "Dummy Track 4",
    src: "/audio/test_four.mp3",
  },
  {
    id: 5,
    title: "Dummy Track 5",
    src: "/audio/test_five.mp3",
  },
];
